export default "__VITE_PUBLIC_ASSET__9fbf0db5__"